import { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  Card,
} from "react-bootstrap";
import Table from "../../Components/UI/Table/Table";
import CsvDownloader from "react-csv-downloader";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ToastAction } from "../../Redux/Actions/ToastAction";
import { IReduxState } from "../../utils/types";
import { GetCampaignsAction, GetOverviewAction } from "../../Redux/Actions/AdsDashboardActions";
import Chart from 'react-apexcharts'
import { ApexOptions } from "apexcharts";
import Spinner from "../../Components/UI/Spinner/Spinner";
import moment from "moment";





const AdsDashboard = () => {

  const dispatch = useDispatch();
  const AdsDashboardState = useSelector(
    (state: IReduxState) => state.AdsDashboard
  );
  const [campaignsList, setCampaignsList] = useState(AdsDashboardState?.campaigns);
  const [csvData, setCsvData] = useState(AdsDashboardState?.campaigns);

  const today = moment().format('YYYY-MM-DD');
  const last7Days = moment().subtract(7, 'days').format('YYYY-MM-DD');

  const cols = [
    { Header: "Campaign Name", accessor: "Line Item Name" },
    { Header: "Impressions", accessor: "Impressions" },
    {
      Header: "Spend", accessor: "Spend", Cell: ({ row }: any) =>
        `${Math.round(row.original.Spend * 1e2) / 1e2}`
    },
    { Header: "Reach", accessor: "Reach" },
  ];

  let newColumns = cols.map((column: any) => ({
    id: column.Header,
    displayName: column.Header,
  }));


  function makeCSV(mylist: any) {
    const ccc = mylist?.map((item: any) => {
      const fixedItem: any = {};
      for (const prop in item) {
        if (item[prop] !== undefined && item[prop] !== null) {
          fixedItem[prop] = typeof item[prop] === 'string' && item[prop].includes(",")
            ? `"${item[prop]}"`
            : item[prop];
        } else {
          fixedItem[prop] = "";
        }
      }
      return {
        ...fixedItem,
        "Campaign Name": fixedItem["Line Item Name"],
        "Impressions": fixedItem.Impressions,
        "Spend": Math.round(fixedItem.Spend * 1e2) / 1e2,
        "Reach": fixedItem.Reach
      };
    });
    setCsvData(ccc);
  }


  const formik: any = useFormik({
    initialValues: {
      startDate: last7Days,
      endDate: today,
      range: "7",
    },
    onSubmit: (value, { resetForm }) => {
      let daterangevalid = true;
      if (value.startDate && value.endDate) {
        let start_dt = new Date(value.startDate);
        let end_dt = new Date(value.endDate);
        if (end_dt < start_dt) {
          daterangevalid = false;
          dispatch(ToastAction({ message: `End date can't be before start date`, severity: 'Danger', show: true }))
        }
      }
      if (daterangevalid) {
        dispatch(GetCampaignsAction(value.startDate, value.endDate));
        // dispatch(GetOverviewAction());

        //filterEventsBySearch(formik.values.search)
      }
    },
  });

  const pieOptions: ApexOptions = {
    labels: ["Spent from the beginning of the month", "Remaining Budget"],
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
      offsetY: 0,
    },
    dataLabels: {
      enabled: false,
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex]
      },
    },
    tooltip: {
      enabled: true
    },
    colors: ['#D67A32', '#4A64BB'],
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  const pieSeries = [AdsDashboardState?.overviews.spent, AdsDashboardState?.overviews.remaining] || [];


  const barOptions: ApexOptions = {
    chart: {
      height: 380,
      type: "bar",
      toolbar: {
        show: false
      }
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        AdsDashboardState?.overviews?.lastSeven?.[6]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[5]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[4]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[3]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[2]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[1]?.Day,
        AdsDashboardState?.overviews?.lastSeven?.[0]?.Day,
      ],
    },
    legend: {
      offsetY: 7,
    },
    // yaxis: {
    //   title: {
    //     text: "$ (thousands)",
    //   },
    // },
    grid: {
      row: {
        colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
        opacity: 0.2,
      },
      borderColor: "#f1f3fa",
    },

    // tooltip: {
    //   y: {
    //     formatter: (val: number) => {
    //       return val;
    //     },
    //   },
    // },
  };

  const barSeries = [
    {
      name: "Impression",
      data: [
        AdsDashboardState?.overviews?.lastSeven?.[6]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[5]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[4]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[3]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[2]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[1]?.Impressions||0,
        AdsDashboardState?.overviews?.lastSeven?.[0]?.Impressions||0,
      ] || [],
    },
    {
      name: "Reach",
      data: [
        AdsDashboardState?.overviews?.lastSeven?.[6]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[5]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[4]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[3]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[2]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[1]?.Reach||0,
        AdsDashboardState?.overviews?.lastSeven?.[0]?.Reach||0] || [],
    },

  ];




  const handleRangeChange = (event: any) => {
    const range = event.target.value;
    const today = moment().format('YYYY-MM-DD');
    let startDate = today;

    switch (range) {
      case '1':
        startDate = today;
        break;
      case '2':
        startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
        break;
      case '7':
        startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
        break;
      case '30':
        startDate = moment().startOf('month').format('YYYY-MM-DD');
        break;
      case '60':
        startDate = moment().subtract(60, 'days').format('YYYY-MM-DD');
        break;
      default:
        startDate = '';
        break;
    }

    formik.setFieldValue('range', range);
    formik.setFieldValue('startDate', startDate);
    formik.setFieldValue('endDate', today);
  };

  useEffect(() => {
    dispatch(GetCampaignsAction(null, null));
    dispatch(GetOverviewAction());

    //setFilteredList(EventLoggerState.events);
  }, [dispatch]);

  useEffect(() => {
    setCampaignsList(AdsDashboardState.campaigns)
    makeCSV(AdsDashboardState.campaigns);
  }, [AdsDashboardState])
  return (
    <>
      <Row className="d-flex justify-content-center mt-3 ms-1">
        <h3 className="module_title" style={{ marginBottom: "0px" }}>
        Ads Dashboard
        </h3>
      </Row>
      <Row className="d-flex justify-content-center mt-2">
        <Col md={6}>
          <Card >
            <Card.Body>
              <h4 className="header-title mt-0 mb-3">MONTHLY BUDGET</h4>
              <Chart options={pieOptions} series={pieSeries} type="pie" height={290} className="apex-charts" dir="ltr" />
            </Card.Body>
          </Card>
          <Row className="d-flex justify-content-center mt-3">
            <Col md={6} >
              <Card>
                <Card.Body>
                <div className="d-flex">
                  <div className="flex-grow-1">
                    <span className="text-muted text-uppercase fs-12 fw-bold">Spent This Month</span>
                    <h3 className="mb-0">{`$${AdsDashboardState?.overviews?.spent ? (Math.round(AdsDashboardState?.overviews?.spent * 100) / 100).toFixed(2) : ""}`}</h3>
                  </div>
                </div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
              <Card.Body>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <span className="text-muted text-uppercase fs-12 fw-bold">Remaining Budget</span>
                  <h3 className="mb-0">{`$${AdsDashboardState?.overviews?.remaining ? (Math.round(AdsDashboardState?.overviews?.remaining * 100) / 100).toFixed(2) : ""}`}</h3>
                </div>
                </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Body>
              <h4 className="header-title mt-0 mb-3">Last 7 days</h4>
              <Chart options={barOptions} series={barSeries} type="bar" height={380} className="apex-charts" dir="ltr" />
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {AdsDashboardState.overviewLoading && (
        <div className="spinnerStyle">
          <Spinner className="m-2" color={"primary"}></Spinner>
        </div>
      )}
      <Row className="d-flex justify-content-start mt-3 flex-row">
        <Col md={12}>
          <Card>
            <Row className="d-flex justify-content-start mt-3" style={{ marginLeft: "initial" }}>
              <Col md="auto">

                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                //className="noMargin"
                >
                  Time Range:
                </Form.Label>
                <Form.Select
                  name="range"
                  value={formik.values.range}
                  onChange={(e) => {
                    handleRangeChange(e);
                    formik.handleChange(e);
                  }}
                  onBlur={formik.handleBlur}
                  className="fsz-875rem"
                >
                  <option value="1">Today</option>
                  <option value="2">Yesterday</option>
                  <option value="7">Last 7 Days</option>
                  <option value="30">This Month</option>
                  <option value="60">Last 60 days</option>
                  <option value="100">Custom</option>
                </Form.Select>
              </Col>
              <Col md="auto" >
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                //className="noMargin"
                >
                  startDate:
                </Form.Label>
                <Form.Control
                  id="example-date"
                  type="date"
                  name="startDate"
                  className="fsz-875rem"
                  value={formik.values.startDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col md="auto" >
                <Form.Label
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                //className="noMargin"
                >
                  End Date:
                </Form.Label>
                <Form.Control
                  id="example-date"
                  type="date"
                  name="endDate"
                  className="fsz-875rem"
                  value={formik.values.endDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Col>
              <Col className="align-content-end d-flex align-items-end ms-auto me-3">
                <Button
                  className="noMargin"
                  onClick={() => {
                    formik.handleSubmit();
                    //setSelectedType("All Events");

                  }}
                  variant="success"
                >
                  Apply
                </Button>
              </Col>
              <Col md="auto" className="d-flex align-items-end ms-auto me-3">

                <CsvDownloader
                  columns={newColumns}
                  datas={csvData}
                  text="Export to CSV"
                  filename={`events_` + new Date().toLocaleString()}
                  extension=".csv"
                  className="btn btn-primary ExportBtn no-margin"
                  style={{ marginBottom: "0px" }}
                />

              </Col>


            </Row>
            <Row className="mt-2 ms-1 me-1">
              {!AdsDashboardState.overviewLoading && AdsDashboardState.loading && (
                <div className="popUpUser">
                  <Spinner className="m-2" color={"primary"}></Spinner>
                </div>
              )}
              <Table
                columns={cols}
                data={campaignsList}
                pageSize={10}
                isSortable={false}
                pagination={true}
                isSearchable={false}
              />
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default AdsDashboard;
